import { Pipe, PipeTransform } from '@angular/core';
import { ContentViewModel, ImgQuery, ObservableContentService, ShallowPreviewOverlayViewModel } from 'osn-shared';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({ name: 'shallowPreviewOverlayVmPipe', pure: false })
export class ShallowPreviewOverlayVmPipe implements PipeTransform {
  constructor(private readonly observableContentService: ObservableContentService) {}

  // eslint-disable-next-line rxjs/finnish
  public transform(value: ContentViewModel, imgQuery: ImgQuery): Observable<ShallowPreviewOverlayViewModel> {
    return this.observableContentService
      .getObservableProgram$(value)
      .shallowOverlayViewModelData.get()
      .pipe(map((result) => ({ ...result, imgQuery })));
  }
}
